export const tourSteps = [
  {
    element: '[data-intro="period-controls"]',
    intro: "Select predefined date ranges or set a custom date range to view trends over specific timeframes.",
    position: 'bottom'
  },
  {
    element: '[data-intro="aggregation-filter"]',
    intro: "Choose how to aggregate your data: Daily (detailed day-by-day), Weekly (grouped by week), or Monthly (grouped by month). The default aggregation changes based on your selected time period.",
    position: 'bottom'
  },
  {
    element: '[data-intro="filter-options"]',
    intro: "Filter trends by options like countries etc.",
    position: 'bottom'
  },
  {
    element: '[data-intro="chart-area"]',
    intro: "Interactive trend chart showing diet request patterns over time. Switch between total view and detailed breakdown of successful diets, warnings, and failures.",
    position: 'top'
  },
  {
    element: '[data-intro="chart-type-selector"]',
    intro: "Choose the type of chart you want to visualize the data - Line, Bar, Area or Pie.",
    position: 'bottom'
  },
  {
    element: '[data-intro="chart-toggle"]',
    intro: "Toggle between Total view (single line with average) and Breakdown view (stacked areas showing different diet result types).",
    position: 'left'
  },
  {
    element: '[data-intro="chart-legend"]',
    intro: "Click on any legend item to show or hide that data series on the chart. Use this to focus on specific metrics or compare different data points.",
    position: 'top'
  },
  {
    element: '[data-intro="summary-stats"]',
    intro: "Key metrics showing average daily/weekly/monthly requests, peak periods, and total period statistics with percentage breakdowns.",
    position: 'top'
  },
  {
    element: '[data-intro="data-table-tour"]',
    intro: "Detailed data table showing all trend data points with exact counts and percentages for each time period.",
    position: 'top'
  }
];

export const chartColors = {
  light: {
    noDiets: '#dc2626',
    noDietsBg: '#dc262640',
    dietsWithWarning: '#d97706',
    dietsWithWarningBg: '#d9770640',
    successfulDiets: '#059669',
    successfulDietsBg: '#05966940',
    total: '#2563eb',
    average: '#4f46e5'
  },
  dark: {
    noDiets: '#f87171',
    noDietsBg: '#f8717160',
    dietsWithWarning: '#fbbf24',
    dietsWithWarningBg: '#fbbf2460',
    successfulDiets: '#34d399',
    successfulDietsBg: '#34d39960',
    total: '#60a5fa',
    average: '#818cf8'
  }
};


export const periodOptions = [
  // Quick Ranges (renamed existing ones)
  { value: '30D', label: 'Last 30 Days', type: 'quick' },
  { value: '180D', label: 'Last 180 Days', type: 'quick' },
  { value: '365D', label: 'Last 365 Days', type: 'quick' },

  // Relative Periods (new)
  { value: 'THIS_WEEK', label: 'This Week', type: 'relative' },
  { value: 'THIS_MONTH', label: 'This Month', type: 'relative' },
  { value: 'THIS_YEAR', label: 'This Year', type: 'relative' },
  { value: 'PREV_WEEK', label: 'Previous Week', type: 'relative' },
  { value: 'PREV_MONTH', label: 'Previous Month', type: 'relative' },
  { value: 'PREV_YEAR', label: 'Previous Year', type: 'relative' },

  // Custom option
  { value: 'CUSTOM', label: 'Custom Range', type: 'custom' }
];

export const getDefaultAggregation = (period) => {
  switch (period) {
    case '30D': return 'daily';
    case '180D': return 'weekly';
    case '365D': return 'monthly';
    case 'THIS_WEEK':
    case 'PREV_WEEK': return 'daily';
    case 'THIS_MONTH':
    case 'PREV_MONTH': return 'daily';
    case 'THIS_YEAR':
    case 'PREV_YEAR': return 'monthly';
    default: return 'daily';
  }
};
